/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PractitionersidPractitioner from './PractitionersidPractitioner';

/**
 * The PractitionersIdBody model module.
 * @module model/PractitionersIdBody
 * @version v0.3
 */
export default class PractitionersIdBody {
  /**
   * Constructs a new <code>PractitionersIdBody</code>.
   * @alias module:model/PractitionersIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PractitionersIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PractitionersIdBody} obj Optional instance to populate.
   * @return {module:model/PractitionersIdBody} The populated <code>PractitionersIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PractitionersIdBody();
      if (data.hasOwnProperty('practitioner'))
        obj.practitioner = PractitionersidPractitioner.constructFromObject(data['practitioner']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PractitionersidPractitioner} practitioner
 */
PractitionersIdBody.prototype.practitioner = undefined;

